export default __webpack_public_path__ + "static/media/pantry1-afterD-2048w.b335f75b.png";